import React from 'react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function TrustBlock() {
  return <section className="w-full py-12 px-6 bg-beige border-t border-dark/5" data-id="element-213">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-dark/60 font-light text-sm" data-id="element-214">
        <div className="flex items-center gap-3" data-id="element-215">
          <ShieldCheckIcon className="w-5 h-5" data-id="element-216" />
          <span data-id="element-217">Compra protegida con Mercado Pago</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-218">
          <LockIcon className="w-5 h-5" data-id="element-219" />
          <span data-id="element-220">Pago 100% seguro</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-221">
          <CreditCardIcon className="w-5 h-5" data-id="element-222" />
          <span data-id="element-223">Certificado SSL</span>
        </div>
      </div>
    </section>;
}